import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function NodeJS() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="Node JS" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                Node JS
              </h1>
              <p className="text-secondary" id="Language_Para">
                Node.Js is a server environment built for fast and easily
                scalable network applications. It was built on Chrome's
                JavaScript runtime and uses an event-driven, non-blocking model
                that makes it the best fit for applications that run on
                distributed devices and need to run in real-time.
                <br />
                Node. js (Node) is an open source, cross-platform runtime
                environment for executing JavaScript code. Node is used
                extensively for server-side programming, making it possible for
                developers to use JavaScript for client-side and server-side
                code without needing to learn an additional language.
                <br />
                In a nutshell, Node. js is a popular programming environment
                that can be used for building high-scale applications that need
                to support multiple concurrent requests. Single-threaded
                non-blocking I/O makes it an excellent choice for both real-time
                and data streaming applications
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
